import { FormBase } from 'core/components';

export default class ChangeClinicalStatusModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'clinicalStatusId',
                    label: 'New Status',
                    placeholder: 'Select Clinical Status',
                    rules: 'required'
                }
            ],
        };
    }
}
